define('lq/services/mpa/addToHomeScreenCommand',[
    'lq/responsive'
], function (responsive) {
    'use strict';

    function AddToHomeScreenCommand(data) {
        this.data = data;
        this.onBeforeInstallPrompt = this.handleBeforeInstallPrompt.bind(this);
    };

    AddToHomeScreenCommand.typeName = 'AddToHomeScreenCommand';

    AddToHomeScreenCommand.deferredPrompt = null;

    AddToHomeScreenCommand.prototype.initialize = function () {
        if (!responsive.isPWA()) {
            // Running in Browser
            window.addEventListener('beforeinstallprompt', this.onBeforeInstallPrompt);
        } else {
            // Running as PWA
            var self = this;
            var eventName = 'alreadyAdded';
            setTimeout(function () {
                if (self.piping.eventing && self.data.eventing[eventName] && self.data.eventing[eventName].enabled) {
                    self.piping.eventing.publish(self.data.eventing[eventName].raisedEventName, null, null, null, self.eventActionId);
                }
            });
        }
    };

    AddToHomeScreenCommand.prototype.handleBeforeInstallPrompt = function (event) {
        event.preventDefault();
        AddToHomeScreenCommand.deferredPrompt = event;
    };

    return AddToHomeScreenCommand;
});

